import React from 'react';
import Markdown from '../../components/Markdown';

/**
 * A vault entry's note, rendered from markdown.
 *
 * This used to be a one-regex linkifier over plain text. The linkifying is
 * still here — it moved into `Markdown`, which applies it inside every text
 * run — but a note is now structured prose: headings, lists, quotes, code.
 * Kept as its own name because that is what the vault row calls it.
 */
export const NoteText: React.FC<{ text: string }> = ({ text }) => <Markdown text={text} dense />;

export default NoteText;
